module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('home-mortgage-banner'), _vm._v(" "), _c('home-strength-intro', {
    attrs: {
      "imgurl": _vm.cycleflex,
      "isSecond": false,
      "slogan": "周期灵活",
      "description": "只需上门1次，即可获得贷款，最快当天拿到钱，随借随还。"
    }
  }), _vm._v(" "), _c('home-strength-intro', {
    attrs: {
      "imgurl": _vm.lowinterest,
      "isSecond": true,
      "slogan": "低利息",
      "description": "日息最低为0.05%，利息合理，降低借贷成本。"
    }
  }), _vm._v(" "), _c('home-strength-intro', {
    attrs: {
      "imgurl": _vm.noworry,
      "isSecond": false,
      "slogan": "服务省心",
      "description": "服务站入驻满洲里、二连浩特、天津、青岛等口岸，提供便捷服务。"
    }
  }), _vm._v(" "), _c('home-strength-intro', {
    attrs: {
      "imgurl": _vm.bigrepo,
      "isSecond": true,
      "slogan": "超大仓库",
      "description": "自营及合作仓库面积12万平米，可存储木材20万立方米。"
    }
  }), _vm._v(" "), _c('home-strength-intro', {
    attrs: {
      "imgurl": _vm.lowthreshold,
      "isSecond": false,
      "slogan": "申请门槛低",
      "description": "有货即贷借，签约简单，只需提供质押人基础信息。"
    }
  }), _vm._v(" "), _c('home-strength-intro', {
    attrs: {
      "imgurl": _vm.safety,
      "isSecond": true,
      "slogan": "安全保障",
      "description": "客户的资料由专业档案室管理，保证资料信息安全，交易协议具有法律保障。"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2adcace3!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/service_intro/mortgage/HomeMortgageContent.vue
// module id = 144
// module chunks = 1